import { Head, Link, usePage } from "@inertiajs/react";

import { Button } from "@/components/ui/button";
import AppLayout from "@/layouts/app-layout";
import { organizationDeliveryNotesPath } from "@/routes";
import type {
  BreadcrumbItem,
  DeliveryNote,
  PagyMetadata,
  RansackFilters,
  SharedData,
} from "@/types";

import { DeliveryNotesDataTable } from "./data-table";

interface DeliveryNotesProps {
  data: {
    delivery_notes: DeliveryNote[];
    pagy: PagyMetadata;
  };
  filters: RansackFilters;
}

export default function DeliveryNotes({ data, filters }: DeliveryNotesProps) {
  const { delivery_notes, pagy } = data;
  const { auth } = usePage<SharedData>().props;
  const organizationSlug = auth.current_organization?.slug ?? "";
  const deliveryNotesHref = organizationDeliveryNotesPath(organizationSlug);
  const uploadNewHref = `/organizations/${organizationSlug}/delivery_notes/upload_new`;
  const breadcrumbs: BreadcrumbItem[] = [
    {
      title: "Remitos",
      href: deliveryNotesHref,
    },
  ];

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Remitos" />
      <div className="flex h-full flex-1 flex-col gap-4 p-4">
        <div className="flex flex-col space-y-2">
          <h2 className="text-2xl font-bold">Remitos</h2>
          <p className="text-muted-foreground">
            Gestiona los remitos de entrega y su procesamiento
          </p>
        </div>

        <div className="flex items-center justify-between">
          <div className="text-sm text-muted-foreground">
            Total: {pagy.count} remitos
          </div>
          <div className="flex gap-2">
            <Button asChild>
              <Link href={uploadNewHref}>Nuevo Remito</Link>
            </Button>
          </div>
        </div>

        <DeliveryNotesDataTable
          deliveryNotes={delivery_notes}
          pagy={pagy}
          filters={filters}
          organizationSlug={organizationSlug}
        />
      </div>
    </AppLayout>
  );
}
